import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import CollectorsComponent from './collectors.component';

let CollectorsModule = angular
  .module('Collectors', [
    uiRouter
  ])
  .component('collectors', CollectorsComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('collectors', {
      url: '/collectors',
      data: {
        authRequired: true,
        permsRequired: ['view-collectors']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'collectors'
        }
      },
      resolve: {
        collectorsObservable: (ContentService, ProfilePermissionsService) => {
          return ProfilePermissionsService.hasPermission('view-collectors') ? ContentService.getCollectorsList() : {};
        },
        posObservable: (ContentService, ProfilePermissionsService) => {
          return ProfilePermissionsService.hasPermission('view-pos') ? ContentService.getPOSList() : {};
        }
      }
    })
  })
  .name;

export default CollectorsModule;



// WEBPACK FOOTER //
// ./src/app/pages/collectors/collectors.module.js